import React from 'react';
import { Link } from "react-router-dom";
import * as util from '../other/util.js';
import ResourcesView from "./resources-view.js";
import ResourceProductionFormulas from "../share/formulas/resource-production-formulas.js";
import * as ICONS from "../other/icons.js";

// The top menu when selecting an owned planet
// allows to navigation to sub menus (construction, ships..) and displays info about the planet
export default class PlanetHeaderView extends React.Component {
    render() {
        let planet = this.props.planet;
        const [consumption, production] = ResourceProductionFormulas.getPlanetResourceDelta(planet);
        let energy_stats = ResourceProductionFormulas.getRawEnergyStats(planet);
        let storage_capacity = ResourceProductionFormulas.getRawStorageCapacity(planet.buildings.storage);
        let housing_capacity = ResourceProductionFormulas.getRawHousingCapacity(planet.buildings.housing);
        let working_worker_count = planet.working_worker_count;

        if (!planet) {
            return (<div />);
        }

        return (
            <div style={{ display: "flex" }}>
                <div style={{ marginRight: "30px" }}>
                    <img src={ICONS.PLANETS[planet.astro_info.icon]} alt={planet.astro_info.icon}
                        style={{ float: "left" }} />
                </div>
                <div>

                    <h1>
                        <div style={{ float: "left" }}>{this.renderLinkToOtherPlanet("<<", planet.previous_planet)}</div>
                        <div style={{ float: "right" }}>{this.renderLinkToOtherPlanet(">>", planet.next_planet)}</div>
                        <div style={{ margin: "0 auto" }}>{planet.name}</div>
                    </h1>

                    <ResourcesView resources={planet.resources}
                        production={production}
                        consumption={consumption}
                        energyStats={energy_stats}
                        storageCapacity={storage_capacity}
                        housingCapacity={housing_capacity}
                        workingWorkerCount={working_worker_count} />

                    {this.renderLinkToSubPage("planet-construction", "Construction")}
                    {this.renderLinkToSubPage("planet-ship-construction", "Shipyard")}
                    {this.renderLinkToSubPage("planet-ship-design", "Ship Design")}
                    {this.renderLinkToSubPage("planet-ships", "Ships")}
                    {this.renderLinkToSubPage("planet-resources", "Resources")}
                </div>
            </div>
        );
    }

    renderLinkToSubPage(page_url, page_name) {
        let planet = this.props.planet;
        let planet_url = util.getPlanetUrl(planet);
        let active_page = this.props.activePage;
        if (page_url === active_page) {
            return (<Link className="link-button-menu" to={{
                pathname: '/game/' + page_url + planet_url,
                force_update: true
            }}>&gt;&gt; {page_name} &lt;&lt;</Link>);
        } else {
            return (<Link className="link-button-menu"
                to={{ pathname: '/game/' + page_url + planet_url, force_update: true }}>{page_name}</Link>);
        }
    }

    renderLinkToOtherPlanet(page_name, planet) {
        let active_page = this.props.activePage;
        let planet_url = util.getPlanetUrl(planet);
        return (<Link className="link-button-menu"
            to={{ pathname: '/game/' + active_page + planet_url, force_update: true }}>{page_name}</Link>);
    }
}
